var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadFillBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Load_Fill",
    "data-name": "Load Fill",
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(78 228)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Carrier_Fill",
    "data-name": "Carrier Fill",
    transform: "translate(80 165.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(0 67.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M0,232.757a.361.361,0,0,0,.362.38H.94a2.559,2.559,0,0,1,2.3-1.5,2.56,2.56,0,0,1,2.3,1.5h7.511v-3.073H0Z",
    transform: "translate(0 -221.852)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M32.175,277.32a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,32.175,277.32Z",
    transform: "translate(-28.937 -266.727)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M281.681,191.777l-1.622-.713H275V196.1h.982a2.508,2.508,0,0,1,4.6,0h.961a.361.361,0,0,0,.362-.38v-3.579A.392.392,0,0,0,281.681,191.777Z",
    transform: "translate(-261.145 -184.817)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M278.391,121.683a1.157,1.157,0,0,0-1.044-.622H275v2.721h4.48Z",
    transform: "translate(-261.145 -118.341)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M11984.047-21114.6H11971v-6.223a1.169,1.169,0,0,1,1.15-1.184h10.739a1.155,1.155,0,0,1,.829.354,1.145,1.145,0,0,1,.327.824v6.229Zm-8.718-4.008a.32.32,0,0,0-.23.1.326.326,0,0,0-.1.238.32.32,0,0,0,.1.229l1.749,1.748a.326.326,0,0,0,.229.1.324.324,0,0,0,.233-.1l3.148-3.148a.323.323,0,0,0,.095-.23.323.323,0,0,0-.095-.23.318.318,0,0,0-.23-.1.318.318,0,0,0-.23.1l-2.921,2.916-1.517-1.521A.32.32,0,0,0,11975.329-21118.6Z",
    transform: "translate(-11971 21122)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M308.008,277.32a1.7,1.7,0,1,0,1.7,1.7h0A1.7,1.7,0,0,0,308.008,277.32Z",
    transform: "translate(-290.873 -266.727)",
    fill: "#13bcd4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadFillBlue);
export default __webpack_public_path__ + "static/media/loadFillBlue.cbb8cc8d4de73b8cc85062e0d5f40746.svg";
export { ForwardRef as ReactComponent };